import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from './tableComponent';
import Sublogin from './elements/sublogin';
import config from '../config';
import { getSid, getItem } from 'src/helpers/session';
import BonusPage from './bonus';

const defaultFraudPercent = 45;

class Component extends TableComponent {
  initialState = {
    from: moment().subtract(1, 'week'),
    to: moment().add(1, 'day'),
    type: 'loc',
    only_sales: true,
    only_frauds: false,
    frauds_active: true,
    agents_enabled: true,
    fraudsPercent: defaultFraudPercent,
    expand: true,
    affType: 'affiliates',
    turbo: true,

    dannyCapLoaded: false,
    dannyCap: 25,
    dannyCapEnabled: false,
    dannyCapDesktopAvailable: false,
    dannyCapSaving: false
  };

  editApiPath = 'affiliates/edit';

  getInitialState = (initialState) => {
    if (this.props.user.role_id >= 3) {
      initialState.expand = false;
      initialState.type = 'loc';
      initialState.only_sales = true;
      initialState.only_frauds = false;
      initialState.fraudsPercent = defaultFraudPercent;
      initialState.frauds_active = true;
      initialState.agents_enabled = true;
      // initialState.from = moment().isoWeekday(1);

      initialState.from = moment().isoWeekday(1).subtract(1, 'week');
      initialState.to = moment().isoWeekday(1).subtract(1, 'day');
    } else {
      initialState.expand = true;
      initialState.type = 'loc';
      initialState.only_sales = false;
      initialState.only_frauds = false;
      initialState.fraudsPercent = defaultFraudPercent;
      // initialState.from = moment().isoWeekday(1);

      initialState.from = moment().isoWeekday(1).subtract(1, 'week');
      initialState.to = moment().isoWeekday(1).subtract(1, 'day');
    }
    return initialState;
  };

  componentWillMount2() {
    this.props.api('settings/get', { key: 'cap' }).then((data) => {
      try {
        // data = JSON.parse(data);
        this.props.setState({
          dannyCapLoaded: true,
          dannyCap: data.limit,
          dannyCapEnabled: data.enabled,
          dannyCapDesktopAvailable: !!data.desktopAvailable
        });
      } catch (err) {
        console.error(err);
      }
    });
    setTimeout(() => {
      this.props.setState({ columns: this.makeColumns() });
      this.setState(this.props.state);
    }, 0);
  }

  getFraudsPercent = (sales, frauds) => {
    if (sales > 0 && frauds > 0) return Math.round((frauds / sales) * 100) + '%';
    return '0%';
  };

  makeColumns = () => {
    let onlyFrauds = this.props.state.only_frauds;
    var columns;
    var expand = this.props.state.expand || this.props.state.initial;
    if (this.props.state.initial && this.props.user.role_id >= 3) {
      expand = false;
    }
    let offer = this.props.state.type;
    let hookupbay = offer == 'hookupbay';
    let showLeads =
      offer == 'cupid' ||
      offer == 'cupid2' ||
      offer == 'loc' ||
      offer == 'hgh2' ||
      offer == 'all_leads';
    let total = this.props.total;
    let scale = getItem('statsScale') || 1;
    let saleScale = 1;
    if (expand) {
      columns = [
        {
          Header: 'Wid',
          accessor: 'aid',
          minWidth: 50,
          Footer: (props) => <span>Total</span>
        },
        {
          Header: (props) => 'Name / Reg date',
          accessor: 'name',
          minWidth: 140,
          Cell: (props) => (
            <div>
              {props.value} <br /> {moment(props.original.date * 1000).format('D MMM YYYY')}
            </div>
          ),
          Footer: (props) => <span>{this.props.total.count || 0}</span>
        },
        {
          Header: (props) => 'Email / Skype',
          accessor: 'email',
          minWidth: 170,
          Cell: (props) => (
            <div>
              {props.value} <br />{' '}
              {props.original.skype != props.original.email ? props.original.skype : ''}
            </div>
          )
        },
        {
          Header: 'Today',
          accessor: 'today_dollars',
          minWidth: 130,
          Cell: (props) => (
            <div>
              <div>
                {!showLeads && <span>{props.original.today_sales * saleScale || 0} sales / </span>}
                {hookupbay && <span> {props.original.today_refunds * saleScale || 0} ref / </span>}
                {showLeads && <span> {props.original.today_trials * saleScale || 0} leads / </span>}
                {!showLeads && <span> $ {props.original.today_dollars * scale || 0} / </span>}
                {showLeads && <span> $ {props.original.today_trial_earnings * scale || 0} / </span>}
                <span> {props.original.today_frauds * saleScale || 0} flagged</span>
              </div>
              <div>
                {props.original.today_visits * saleScale || 0} visits /{' '}
                {props.original.today_unique * saleScale || 0} uniq /{' '}
                {this.getFraudsPercent(props.original.today_sales, props.original.today_frauds) +
                  ' flagged'}
              </div>
            </div>
          ),
          Footer: (props) => (
            <div>
              {!showLeads && <div>$ {this.props.total.today_dollars * scale || 0}</div>}
              {showLeads && <div>$ {this.props.total.today_trial_earnings * scale || 0}</div>}
              {!showLeads && <div>{this.props.total.today_sales * saleScale || 0} sales</div>}
              <div>{this.props.total.today_visits * saleScale || 0} visits</div>
              <div>{this.props.total.today_unique * saleScale || 0} unique</div>
              <div>{this.props.total.today_frauds * saleScale || 0} flagged</div>
              {hookupbay && <div>{this.props.total.today_refunds * saleScale || 0} refunds</div>}
              {showLeads && <div>{this.props.total.today_trials * saleScale || 0} leads</div>}
            </div>
          )
        },
        {
          Header: 'Yesterday',
          accessor: 'yesterday_dollars',
          minWidth: 130,
          Cell: (props) => (
            <div>
              <div>
                {!showLeads && (
                  <span>{props.original.yesterday_sales * saleScale || 0} sales /</span>
                )}
                {hookupbay && (
                  <span> {props.original.yesterday_refunds * saleScale || 0} ref / </span>
                )}
                {showLeads && (
                  <span> {props.original.yesterday_trials * saleScale || 0} leads / </span>
                )}
                {!showLeads && <span> $ {props.original.yesterday_dollars * scale || 0} / </span>}
                {showLeads && (
                  <span> $ {props.original.yesterday_trial_earnings * scale || 0} / </span>
                )}
                <span>{props.original.yesterday_frauds * saleScale || 0} flagged</span>
              </div>
              <div>
                {props.original.yesterday_visits * saleScale || 0} visits /{' '}
                {props.original.yesterday_unique * saleScale || 0} uniq /{' '}
                {this.getFraudsPercent(
                  props.original.yesterday_sales,
                  props.original.yesterday_frauds
                ) + ' flagged'}
              </div>
            </div>
          ),
          Footer: (props) => (
            <div>
              {!showLeads && <div>$ {this.props.total.yesterday_dollars * scale || 0}</div>}
              {showLeads && <div>$ {this.props.total.yesterday_trial_earnings * scale || 0}</div>}
              {!showLeads && <div>{this.props.total.yesterday_sales * saleScale || 0} sales</div>}
              <div>{this.props.total.yesterday_visits * saleScale || 0} visits</div>
              <div>{this.props.total.yesterday_unique * saleScale || 0} unique</div>
              <div>{this.props.total.yesterday_frauds * saleScale || 0} flagged</div>
              {hookupbay && (
                <div>{this.props.total.yesterday_refunds * saleScale || 0} refunds</div>
              )}
              {showLeads && <div>{this.props.total.yesterday_trials * saleScale || 0} leads</div>}
            </div>
          )
        },
        {
          Header: 'Last week',
          accessor: 'week_dollars',
          minWidth: 150,
          Cell: (props) => (
            <div>
              <div>
                {!showLeads && <span>{props.original.week_sales * saleScale || 0} sales /</span>}
                {hookupbay && <span> {props.original.week_refunds * saleScale || 0} ref / </span>}
                {showLeads && <span> {props.original.week_trials * saleScale || 0} leads / </span>}
                {!showLeads && <span> $ {props.original.week_dollars * scale || 0} / </span>}
                {showLeads && <span> $ {props.original.week_trial_earnings * scale || 0} / </span>}
                <span>{props.original.week_frauds * saleScale || 0} flagged</span>
              </div>
              <div>
                {props.original.week_visits * saleScale || 0} visits /{' '}
                {props.original.week_unique * saleScale || 0} uniq /{' '}
                {this.getFraudsPercent(props.original.week_sales, props.original.week_frauds) +
                  ' flagged'}
              </div>
            </div>
          ),
          Footer: (props) => (
            <div>
              {!showLeads && <div>$ {this.props.total.week_dollars * scale || 0}</div>}
              {showLeads && <div>$ {this.props.total.week_trial_earnings * scale || 0}</div>}
              {!showLeads && <div>{this.props.total.week_sales * saleScale || 0} sales</div>}
              <div>{this.props.total.week_visits * saleScale || 0} visits</div>
              <div>{this.props.total.week_unique * saleScale || 0} unique</div>
              <div>{this.props.total.week_frauds * saleScale || 0} flagged</div>
              {hookupbay && <div>{this.props.total.week_refunds * saleScale || 0} refunds</div>}
              {showLeads && <div>{this.props.total.week_trials * saleScale || 0} leads</div>}
            </div>
          )
        },
        {
          Header: (props) =>
            this.props.state.from.format('D MMM') + ' - ' + this.props.state.to.format('D MMM'),
          accessor: 'between_dollars',
          minWidth: 170,
          Cell: (props) => (
            <div>
              <div>
                {!showLeads && <span>{props.original.between_sales * saleScale || 0} sales /</span>}
                {hookupbay && (
                  <span> {props.original.between_refunds * saleScale || 0} ref / </span>
                )}
                {showLeads && (
                  <span> {props.original.between_trials * saleScale || 0} leads / </span>
                )}
                {!showLeads && <span> $ {props.original.between_dollars * scale || 0} / </span>}
                {showLeads && (
                  <span> $ {props.original.between_trial_earnings * scale || 0} / </span>
                )}
                <span>{props.original.between_frauds * saleScale || 0} flagged</span>
              </div>
              <div>
                {props.original.between_visits * saleScale || 0} visits /{' '}
                {props.original.between_unique * saleScale || 0} uniq /{' '}
                {this.getFraudsPercent(
                  props.original.between_sales,
                  props.original.between_frauds
                ) + ' flagged'}
              </div>
            </div>
          ),
          Footer: (props) => (
            <div>
              {!showLeads && <div>$ {this.props.total.between_dollars * scale || 0}</div>}
              {showLeads && <div>$ {this.props.total.between_trial_earnings * scale || 0}</div>}
              {!showLeads && <div>{this.props.total.between_sales * saleScale || 0} sales</div>}
              <div>{this.props.total.between_visits * saleScale || 0} visits</div>
              <div>{this.props.total.between_unique * saleScale || 0} unique</div>
              <div>{this.props.total.between_frauds * saleScale || 0} flagged</div>
              {hookupbay && <div>{this.props.total.between_refunds * saleScale || 0} refunds</div>}
              {showLeads && <div>{this.props.total.between_trials * saleScale || 0} leads</div>}
            </div>
          )
        }
      ];
    } else {
      columns = [
        {
          Header: 'Wid',
          accessor: 'aid',
          minWidth: 50,
          Footer: (props) => <span>Total</span>
        },
        {
          Header: (props) => 'Name',
          accessor: 'name',
          minWidth: 150,
          Cell: (props) => <div>{props.value}</div>,
          Footer: (props) => <span>{this.props.total.count || 0}</span>
        },
        {
          Header: (props) => 'Email ',
          accessor: 'email',
          minWidth: 180
        },
        {
          Header: 'Today',
          accessor: 'today_dollars',
          minWidth: 130,
          Cell: (props) => (
            <div>
              {!showLeads && <span>{props.original.today_sales * saleScale || 0} sales /</span>}
              {hookupbay && <span> {props.original.today_refunds * saleScale || 0} ref / </span>}
              {showLeads && <span> {props.original.today_trials * saleScale || 0} leads / </span>}
              {!onlyFrauds && !showLeads && (
                <span> $ {props.original.today_dollars * scale || 0}</span>
              )}
              {!onlyFrauds && showLeads && (
                <span> $ {props.original.today_trial_earnings * scale || 0}</span>
              )}
              {onlyFrauds && <span> {props.original.today_frauds * saleScale || 0} flagged /</span>}
              {onlyFrauds && (
                <span>
                  {' ' +
                    this.getFraudsPercent(props.original.today_sales, props.original.today_frauds)}
                </span>
              )}
            </div>
          ),
          // Footer: props => <div>{this.props.total.today_sales || 0} sales <br /> $ {this.props.total.today_dollars || 0}</div>
          Footer: (props) => (
            <div>
              {!showLeads && <div>{this.props.total.today_sales * saleScale || 0} sales</div>}
              {hookupbay && <div>{this.props.total.today_refunds * saleScale || 0} refunds</div>}
              {showLeads && <div>{this.props.total.today_trials * saleScale || 0} leads</div>}
              {!showLeads && <div>$ {this.props.total.today_dollars * scale || 0}</div>}
              {showLeads && <div>$ {this.props.total.today_trial_earnings * scale || 0}</div>}
              <div> {this.props.total.today_frauds * saleScale || 0} flagged</div>
            </div>
          )
        },
        {
          Header: 'Yesterday',
          accessor: 'yesterday_dollars',
          minWidth: 130,
          Cell: (props) => (
            <div>
              {!showLeads && <span>{props.original.yesterday_sales * saleScale || 0} sales /</span>}
              {hookupbay && (
                <span> {props.original.yesterday_refunds * saleScale || 0} ref / </span>
              )}
              {showLeads && (
                <span> {props.original.yesterday_trials * saleScale || 0} leads / </span>
              )}
              {!onlyFrauds && !showLeads && (
                <span> $ {props.original.yesterday_dollars * scale || 0}</span>
              )}
              {!onlyFrauds && showLeads && (
                <span> $ {props.original.yesterday_trial_earnings * scale || 0}</span>
              )}
              {onlyFrauds && (
                <span> {props.original.yesterday_frauds * saleScale || 0} flagged /</span>
              )}
              {onlyFrauds && (
                <span>
                  {' ' +
                    this.getFraudsPercent(
                      props.original.yesterday_sales,
                      props.original.yesterday_frauds
                    )}
                </span>
              )}
            </div>
          ),
          Footer: (props) => (
            <div>
              {!showLeads && <div>{this.props.total.yesterday_sales * saleScale || 0} sales</div>}
              {hookupbay && (
                <div>{this.props.total.yesterday_refunds * saleScale || 0} refunds</div>
              )}
              {showLeads && <div>{this.props.total.yesterday_trials * saleScale || 0} leads</div>}
              {!showLeads && <div>$ {this.props.total.yesterday_dollars * scale || 0}</div>}
              {showLeads && <div>$ {this.props.total.yesterday_trial_earnings * scale || 0}</div>}
              <div>{this.props.total.yesterday_frauds * saleScale || 0} flagged</div>
            </div>
          )
        },
        {
          Header: 'Last week',
          accessor: 'week_dollars',
          minWidth: 150,
          Cell: (props) => (
            <div>
              {!showLeads && <span>{props.original.week_sales * saleScale || 0} sales /</span>}
              {hookupbay && <span> {props.original.week_refunds * saleScale || 0} ref / </span>}
              {showLeads && <span> {props.original.week_trials * saleScale || 0} leads / </span>}
              {!onlyFrauds && !showLeads && (
                <span> $ {props.original.week_dollars * scale || 0}</span>
              )}
              {!onlyFrauds && showLeads && (
                <span> $ {props.original.week_trial_earnings * scale || 0}</span>
              )}
              {onlyFrauds && <span> {props.original.week_frauds * saleScale || 0} flagged /</span>}
              {onlyFrauds && (
                <span>
                  {' ' +
                    this.getFraudsPercent(props.original.week_sales, props.original.week_frauds)}
                </span>
              )}
            </div>
          ),
          Footer: (props) => (
            <div>
              {!showLeads && <div>{this.props.total.week_sales * saleScale || 0} sales</div>}
              {hookupbay && <div>{this.props.total.week_refunds * saleScale || 0} refunds</div>}
              {showLeads && <div>{this.props.total.week_trials * saleScale || 0} leads</div>}
              {!showLeads && <div>$ {this.props.total.week_dollars * scale || 0}</div>}
              {showLeads && <div>$ {this.props.total.week_trial_earnings * scale || 0}</div>}
              <div>{this.props.total.week_frauds * saleScale || 0} flagged</div>
            </div>
          )
        },
        {
          Header: (props) =>
            this.props.state.from.format('D MMM') + ' - ' + this.props.state.to.format('D MMM'),
          accessor: 'between_dollars',
          minWidth: 150,
          Cell: (props) => (
            <div>
              {!showLeads && <span>{props.original.between_sales * saleScale || 0} sales /</span>}
              {hookupbay && <span> {props.original.between_refunds * saleScale || 0} ref / </span>}
              {showLeads && <span> {props.original.between_trials * saleScale || 0} leads / </span>}
              {!onlyFrauds && !showLeads && (
                <span> $ {props.original.between_dollars * scale || 0}</span>
              )}
              {!onlyFrauds && showLeads && (
                <span> $ {props.original.between_trial_earnings * scale || 0}</span>
              )}
              {onlyFrauds && (
                <span> {props.original.between_frauds * saleScale || 0} flagged /</span>
              )}
              {onlyFrauds && (
                <span>
                  {' ' +
                    this.getFraudsPercent(
                      props.original.between_sales,
                      props.original.between_frauds
                    )}
                </span>
              )}
            </div>
          ),
          Footer: (props) => (
            <div>
              {!showLeads && <div>{this.props.total.between_sales * saleScale || 0} sales</div>}
              {hookupbay && <div>{this.props.total.between_refunds * saleScale || 0} refunds</div>}
              {showLeads && <div>{this.props.total.between_trials * saleScale || 0} leads</div>}
              {!showLeads && <div>$ {this.props.total.between_dollars * scale || 0}</div>}
              {showLeads && <div>$ {this.props.total.between_trial_earnings * scale || 0}</div>}
              <div>{this.props.total.between_frauds * saleScale || 0} flagged</div>
            </div>
          )
        }
      ];
    }

    if (this.props.user.role_id >= 3 && !expand && false) {
      columns.push({
        Header: '',
        accessor: 'aid',
        id: 'pay',
        sortable: false,
        minWidth: 80,
        Cell: (props) => <button class='btn btn-sm primary'>Pay</button>
      });
    } else {
      columns.push({
        Header: (props) => {
          if (!this.props.state.only_frauds) return '';
          if (this.props.editManyApiState.loading || this.props.loading) return 'Updating...';
          return (
            <div>
              <div>
                <button
                  type='button'
                  class={
                    'btn btn-sm btn-block p-0 btn-aff-toggle ' +
                    (this.props.state.frauds_active ? 'warning' : 'white')
                  }
                  onClick={(e) => {
                    this.toggleAllActive();
                  }}
                >
                  Active
                </button>
              </div>
              {expand && (
                <div>
                  <button
                    type='button'
                    class={
                      'btn btn-sm btn-block p-0 btn-aff-toggle mt-1 ' +
                      (this.props.state.agents_enabled ? 'success' : 'white')
                    }
                    onClick={(e) => {
                      this.toggleAllAgents();
                    }}
                  >
                    Agents
                  </button>
                </div>
              )}
            </div>
          );
        },
        accessor: 'aid',
        id: 'pay',
        sortable: false,
        minWidth: 70,
        Cell: (props) => (
          <div>
            {(!onlyFrauds || (onlyFrauds && expand)) && (
              <div>
                <Sublogin aid={props.value} class='p-0' />
              </div>
            )}
            {onlyFrauds && (
              <div>
                <button
                  type='button'
                  class={
                    'btn btn-sm btn-block p-0 mt-1 btn-aff-toggle ' +
                    (parseInt(props.original.active) ? 'warning' : 'white')
                  }
                  onClick={(e) => {
                    this.handleToggleData(!parseInt(props.original.active), props, 'active');
                  }}
                >
                  Active
                </button>
              </div>
            )}
            {expand && onlyFrauds && (
              <div>
                <button
                  type='button'
                  class={
                    'btn btn-sm btn-block p-0 mt-1 btn-aff-toggle ' +
                    (parseInt(props.original.agents_enabled) ? 'success' : 'white')
                  }
                  onClick={(e) => {
                    this.handleToggleData(
                      !parseInt(props.original.agents_enabled),
                      props,
                      'agents_enabled'
                    );
                  }}
                >
                  Agents
                </button>
              </div>
            )}
            {expand && !onlyFrauds && (
              <div>
                <Link
                  class='btn btn-sm btn-block warning mt-1 p-0'
                  to={config.basePath + '/affiliate/' + props.value + '/sales'}
                >
                  Sales
                </Link>
              </div>
            )}
          </div>
        )
      });
    }
    return columns;
  };

  apiPath = 'master/stats2';

  tableParams = {
    manual: true,
    sorted: [
      {
        id: 'week_dollars',
        desc: true
      }
    ],
    showAll: false
  };
  fetchParams = (state) => {
    let onlyFrauds = this.props.state.only_frauds;
    let onlySales = this.props.state.only_sales;
    return {
      only_sales: onlyFrauds || onlySales,
      only_frauds: onlyFrauds,
      fraudsPercent: onlyFrauds ? this.props.state.fraudsPercent : 0,
      load_all: onlyFrauds || onlySales,
      affType: this.props.state.affType || 'affiliates',
      turbo: !!this.props.state.turbo
    };
  };

  typeOptions = [
    { name: 'Cupid3 Leads', value: 'loc' },
    { name: 'Loans', value: 'hgh2' },
    { name: 'Cupid Leads', value: 'cupid' },
    { name: 'CPS', value: 'andy1' },
    { name: 'All Leads', value: 'all_leads' },
    { name: 'All Sales', value: 'all' },
    { name: 'Cupid2 Leads', value: 'cupid2' },
    { name: 'H Links', value: 'chatsales' },
    { name: 'Easy SX', value: 'danny' },
    { name: 'A Links', value: 'andy' },
    { name: 'Gold Links', value: 'dgold' },
    { name: 'A3', value: 'andy30' },
    { name: 'A6', value: 'andy60' },
    { name: 'KLinks', value: 'chris' },
    { name: 'C.link.old', value: 'chris2' },
    { name: 'IFramecash', value: 'sexplaycam' },
    { name: 'Livecam', value: 'imlive' },
    { name: 'CeVIP', value: 'cevip' },
    { name: 'Wellhello', value: 'wellhello' },
    { name: 'H1', value: 'hg1' },
    { name: 'HBay', value: 'hookupbay' },
    { name: 'PunkBank', value: 'punk' },
    { name: 'PunkBank1', value: 'punk1' },
    { name: 'SLinks', value: 'sms' }
  ];

  toggleExpand = (e) => {
    let expand = e.target.checked;

    this.props.setState({ expand }, () => {
      this.forceUpdate(() => {
        setTimeout(() => {
          this.props.setState({ columns: this.makeColumns() });
          this.setState(this.props.state);
        }, 200);
      });
    });
  };

  toggleTurbo = (e) => {
    let turbo = e.target.checked;

    this.props.setState({ turbo }, () => {});
    this.fetchData({ forceReload: true });
    // this.forceUpdate();
  };

  showAgents = (e) => {
    this.props.setState({ affType: 'agents' }, () => this.setState(this.props.state));
  };

  toggleAllActive = () => {
    if (this.props.editManyApiState.loading)
      return console.log('editManyApiState.loading, prevent');
    console.log('toggleAllActive', this.props.state.frauds_active);
    let value = !this.props.state.frauds_active;
    this.props.setState({ frauds_active: value });

    let ids = this.props.items.map((item) => item.aid);
    this.props.api('affiliates/editmany', { ids, key: 'active', value }).then((res) => {
      console.log('editmany done', res);
      this.fetchData({ forceReload: true });
    });
    this.forceUpdate();
  };
  toggleAllAgents = () => {
    if (this.props.editManyApiState.loading)
      return console.log('editManyApiState.loading, prevent');
    console.log('toggleAllActive', this.props.state.agents_enabled);
    let value = !this.props.state.agents_enabled;
    this.props.setState({ agents_enabled: value });

    let ids = this.props.items.map((item) => item.aid);
    this.props.api('affiliates/editmany', { ids, key: 'agents_enabled', value }).then((res) => {
      console.log('editmany done', res);
      this.fetchData({ forceReload: true });
    });
    this.forceUpdate();
  };

  onChangeDannyCap = (e) => {
    this.props.setState({ dannyCap: e.target.value }, this.saveSettings);
  };

  onChangeDannyCapEnabled = (val) => {
    this.props.setState({ dannyCapEnabled: val }, this.saveSettings);
  };

  onChangeDannyCapDesktopAvailable = (val) => {
    this.props.setState({ dannyCapDesktopAvailable: val }, this.saveSettings);
  };

  saveSettings = () => {
    clearTimeout(this.saveSettingsTimeout);
    this.saveSettingsTimeout = setTimeout(() => {
      this.props.api('settings/set', {
        key: 'cap',
        value: {
          limit: this.props.state.dannyCap,
          enabled: this.props.state.dannyCapEnabled,
          desktopAvailable: this.props.state.dannyCapDesktopAvailable
        }
      });
    }, 1000);
  };

  render() {
    this.tableParams.showAll = this.props.state.only_sales || this.props.state.only_frauds;
    let showAgents = this.props.state.affType === 'agents';
    let onlyFrauds = this.props.state.only_frauds;
    let dannyCapEnabled = this.props.state.dannyCapEnabled || this.initialState.dannyCapEnabled;
    let dannyCap = this.props.state.dannyCap || this.initialState.dannyCap;
    let dannyCapDesktopAvailable =
      this.props.state.dannyCapDesktopAvailable || this.initialState.dannyCapDesktopAvailable;
    let dannyLoaded = this.props.state.dannyCapLoaded;
    return (
      <div class='co__pg-all-stats'>
        {!this.props.state.initial && (
          <div>
            {this.props.user.role_id >= 4 && (
              <div class='row table-head-controls mb-2 co__table-filters'>
                <div class='col-sm'>
                  {this.props.user.role_id >= 3 && (
                    <div class='btn-group'>
                      {this.typeButton('Admins', 'admins', '', null, 'affType')}
                      {this.typeButton('Masters', 'masters', '', null, 'affType')}
                      {this.typeButton('Affiliates', 'affiliates', '', null, 'affType')}
                      {this.typeButton('Agents', 'agents', '', this.showAgents, 'affType')}
                      {false && this.typeButton('Banned', 'banned', '', null, 'affType')}
                    </div>
                  )}
                </div>
                {!showAgents && (
                  <div class='col-sm'>
                    <Link class='mt-1 p-0 pull-right' to={config.basePath + '/all_stats'}>
                      Old stats
                    </Link>
                  </div>
                )}
              </div>
            )}
            {!showAgents && (
              <div class='row table-head-controls'>
                <div class='col-12'>
                  {this.datepickerElement({ weekArrows: true })}
                  {this.props.user.role_id >= 2 && !onlyFrauds && (
                    <div class='d-inline-block ml-2'>
                      <label class='ui-switch ui-switch-md info m-t-xs table-head-switch'>
                        <input
                          type='checkbox'
                          name='only_sales'
                          checked={this.props.state.only_sales}
                          onChange={this.changeType}
                        />
                        <i></i>
                      </label>
                      <span class='ml-1 switch-description'>Active</span>
                    </div>
                  )}
                  {!onlyFrauds && (
                    <a
                      target='_blank'
                      href={
                        '/app/api/master/stats_export2?sid=' +
                        getSid() +
                        '&only_sales=' +
                        Number(this.props.state.only_sales) +
                        '&type=' +
                        this.props.state.type +
                        '&from=' +
                        this.props.state.from.format('DD-MM-YYYY') +
                        '&to=' +
                        this.props.state.to.format('DD-MM-YYYY')
                      }
                    >
                      <button class='btn btn-sm primary ml-2'>CSV</button>
                    </a>
                  )}
                  {true && (
                    <div class='d-inline-block ml-2'>
                      <label class='ui-switch ui-switch-md info m-t-xs table-head-switch'>
                        <input
                          type='checkbox'
                          name='expand'
                          checked={this.props.state.expand}
                          onChange={(e) => this.toggleExpand(e, true)}
                        />
                        <i></i>
                      </label>
                      <span class='ml-1 switch-description'>Expand</span>
                    </div>
                  )}
                  {this.props.user.role_id >= 4 && (
                    <div class='d-inline-block ml-2'>
                      <label class='ui-switch ui-switch-md info m-t-xs table-head-switch'>
                        <input
                          type='checkbox'
                          name='only_frauds'
                          checked={this.props.state.only_frauds}
                          onChange={this.changeType}
                        />
                        <i></i>
                      </label>
                      <span class='ml-1 switch-description'>Flagged</span>
                    </div>
                  )}
                  {this.props.state.only_frauds && (
                    <form
                      onSubmit={this.submitInput.bind(this, 'fraudsPercent')}
                      class='tables-search d-inline-block ml-2'
                      style={{ verticalAlign: 'top' }}
                    >
                      <input
                        class={'form-control form-control-sm d-inline-block'}
                        type='number'
                        placeholder='Percent...'
                        name='fraudsPercent'
                        style={{ maxWidth: '50px' }}
                        defaultValue={this.props.state.fraudsPercent}
                        onChange={this.handleChangeInput.bind(this, 'fraudsPercent')}
                        onBlur={this.submitInput.bind(this, 'fraudsPercent')}
                      />
                      <span class='pull-right ml-1' style={{ lineHeight: '29px' }}>
                        %
                      </span>
                    </form>
                  )}
                  {this.props.user.role_id >= 4 && (
                    <div class='d-inline-block ml-2'>
                      <label class='ui-switch ui-switch-md info m-t-xs table-head-switch'>
                        <input
                          type='checkbox'
                          name='turbo'
                          checked={this.props.state.turbo}
                          onChange={(e) => this.toggleTurbo(e, true)}
                        />
                        <i></i>
                      </label>
                      <span class='ml-1 switch-description'>Turbo</span>
                    </div>
                  )}

                  <div class='pull-right'>{this.searchElement()}</div>
                  {this.props.user.role_id >= 3 && (
                    <select
                      class='form-control form-control-sm table-select mr-4 pull-right'
                      onChange={this.changeType}
                      name='type'
                    >
                      {this.typeOptions.map((offer) => (
                        <option key={offer.value} value={offer.value}>
                          {offer.name}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        {this.props.user.role_id >= 4 && !showAgents && dannyLoaded && (
          <div class='row mt-2'>
            <div class='col-sm col-sm-12 text-center co__table-filters'>
              <div class='pull-left'>
                <span class='p-2'>Easy Cap:</span>
                <input
                  class={'form-control form-control-sm d-inline-block'}
                  style={{
                    width: '70px'
                  }}
                  type='number'
                  name='dannyCap'
                  defaultValue={this.props.state.dannyCap}
                  onChange={this.onChangeDannyCap}
                />
              </div>
              <div class='pull-left'>
                <button
                  class={'btn btn-sm ml-2 ' + (dannyCapEnabled ? 'warning' : '')}
                  onClick={() => this.onChangeDannyCapEnabled(!dannyCapEnabled)}
                >
                  {dannyCapEnabled ? 'Enabled' : 'Disabled'}
                </button>
              </div>
              <div class='pull-left'>
                <button
                  class={'btn btn-sm ml-2 ' + (dannyCapDesktopAvailable ? 'warning' : '')}
                  style={{ fontWeight: 400 }}
                  onClick={() => this.onChangeDannyCapDesktopAvailable(!dannyCapDesktopAvailable)}
                >
                  {dannyCapDesktopAvailable ? 'Easy desktop available' : 'Easy desktop disabled'}
                </button>
              </div>
            </div>
          </div>
        )}
        {!showAgents && (
          <div class='row'>
            <div class='col-sm-12'>
              <div class='box mt-2'>{this.reactTable()}</div>
            </div>
          </div>
        )}
        {showAgents && <BonusPage />}
      </div>
    );
  }
}

export default connect(Component, 'master_stats2', function (state) {
  return {
    editApiState: state.api.affiliates_edit || state.api.initial,
    editManyApiState: state.api.affiliates_editmany || state.api.initial,
    getSettingsApiState: state.api.settings_get || state.api.initial,
    saveSettingsApiState: state.api.settings_set || state.api.initial
  };
});
